import React from 'react';
import { Stack } from '../../../atoms/stack/Stack';
import { Row } from '../../../atoms/row/Row';
import { Typography } from '../../../atoms/typography/Typography';
import StarRating from '../../shared/starRating/StarRating';
import { LinkButton } from '../../../atoms/linkButton/LinkButton';

const AlternativeItem = ({ data, showMore = false, t }) => (
  <Stack className="flex-1 bg-white rounded-2xl shadow-lg border border-customGray-200 p-6 gap-4">
    <Row className="w-full py-2 items-center gap-4 border-b border-customGray-200">
      <img
        className="w-[60px] h-[60px] min-w-[60px]"
        src={data.imgUrl}
        alt={data.name}
      />
      <Stack className="flex-1 h-full items-start justify-between py-2 gap-1 max-h-18">
        <Typography
          className="overflow-hidden line-clamp-2"
          textAlign="left"
          fontVariant="h7"
        >
          {data.name}
        </Typography>
        <StarRating
          width={12}
          height={12}
          fillColor="#FEC84B"
          rating={data.rating}
        />
      </Stack>
    </Row>
    {/*
    <Typography
      className="!text-customGray-500 mt-4 min-h-20"
      textAlign="center"
      fontVariant="sm"
    >
      {data.description}
    </Typography>
    */}
    <Row className="flex-1">
      <LinkButton
        label={t('systemCard.compare')}
        variant="transparent"
        href={data.compareHref}
        textTransform="uppercase"
        size="lg"
        className="w-full border border-customGray-300"
      />
      {showMore && (
        <LinkButton
          label={t('systemCard.readMore')}
          variant="transparent"
          href={data.showMoreHref}
          textTransform="uppercase"
          size="lg"
          className="w-full border border-customGray-300"
        />
      )}
    </Row>
  </Stack>
);

export default AlternativeItem;
